module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADISURBVEhL5ZRRCsIwEAVzENHjKHphoYJ3UY9QBX9S38pAqkEblwQRBxbZTd40DdTwP8QYF6pO1fM7Y6kOEu6GEeq3LPmQYHziveqK+45646Lq1M6JlaPgw4nfYQ8hVo5CZ/KT2F5i02jzRnUiW4xlVGs0r9GmI5mPUfaAJseebqdgrxtzqFZoExq6T/6MXPmbsDbQukGTe5hXA22CeTXQJpi3vyJaN2i+eEW1QJtg3v6KaN2gyT3Nv2T7/7AF9rgxh2qJ9ucJ4QaFlvgDyBnzCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-compost-heap/light/24.png
// module id = 1954
// module chunks = 2